import type { FormControlKey } from "shared"
import { checkbox } from "./checkbox"
import { checkboxGroup } from "./checkboxGroup"
import { datePicker } from "./datePicker"
import { dateTimePicker } from "./dateTimePicker"
import { dropdownMulti } from "./dropdownMulti"
import { dropdownSingle } from "./dropdownSingle"
import { multilineText } from "./multilineText"
import { number } from "./number"
import { radioGroup } from "./radioGroup"
import { singleLineText } from "./singleLineText"
import { toggleSwitch } from "./toggleSwitch"
import type { ControlInspector } from "./types"

export type { ControlInspector, FieldEdit, InspectorProps } from "./types"

export const INSPECTORS: { [K in FormControlKey]: ControlInspector<K> } = {
  singleLineText,
  multilineText,
  number,
  checkbox,
  dropdownSingle,
  dropdownMulti,
  radioGroup,
  checkboxGroup,
  datePicker,
  dateTimePicker,
  toggleSwitch,
}

/**
 * The inspector for a control, typed by its key: a caller holding a field of
 * one control gets an `Inspector` that takes that field, and a caller holding
 * any field gets one that takes any field.
 */
export const inspectorFor = <K extends FormControlKey>(
  control: K,
): ControlInspector<K> => INSPECTORS[control]
